export const PREFIX_CLS = 'ant-fullcalendar'



// WEBPACK FOOTER //
// ./components/calendar/Constants.js